import React, { FC } from 'react'

import { IconIdeaProps } from './IconIdea.types'
import * as Styled from './styles/IconIdea.style'

import { nonThemeableRules } from '../../ruleSet'

const IconIdea: FC<IconIdeaProps> = ({
  size = nonThemeableRules.defaultSize as number as IconIdeaProps['size'],
  isResponsive = false,
}: IconIdeaProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M36.69 18.25a11.892 11.892 0 0 1-1.707 6.1c-.454.766-.96 1.5-1.515 2.195 0 0-2.68 2.555-2.68 5.727a.974.974 0 0 1-.978.976H18.1a.975.975 0 0 1-.978-.975c0-3.173-2.59-5.733-2.59-5.733a19.141 19.141 0 0 1-1.514-2.197 11.892 11.892 0 0 1-1.708-6.1v-.653c.313-6 5.225-11.425 12.225-11.667h.895c7.545 0 12.235 6.52 12.235 11.71l.025.617Z'
          stroke='#0D0D0D'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M16.25 18.663a7.803 7.803 0 0 1 3.845-6.736'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M17.613 36.23h12.774M19.05 39.158h9.907m-8.342 2.927h6.878'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconIdea
